import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';

// Create the base query using axios
const baseQuery = axiosBaseQuery({
  baseUrl: '',
});

// Base query with error handling
const baseQueryWithErrorHandling = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  // Handle common error cases
  if (result.error) {
    if (result.error.status === 401) {
      // Handle unauthorized - you might want to dispatch a logout action
      // api.dispatch(logout());
      console.error('Unauthorized access - token might be expired');
    }
    if (result.error.status === 'FETCH_ERROR') {
      console.error('Network error - check your connection');
    }
  }

  return result;
};

// Create the base API slice
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: [
    // Add your tag types here for cache invalidation
    'User',
    'School',
    'Course',
    'Assignment',
    'Student',
    'Teacher',
    'StudentPoint',
    'SettingStudentPoint',
    'StudentPointHandling',
    'StudentPointHandlingDetail',
    'BackgroundProcess',
    'ExamLog',
    'ExamLogUser',
    'Notifications',
    'NotificationsCount',
    // Add more as needed
  ],
  endpoints: () => ({}), // We'll inject endpoints in feature-specific files
});
